import Cookies from 'js-cookie';

export default class TopNotice {
    constructor() {
        $('.top-notice__close').on('click.TopNotice', this.close.bind(this));

        $(document).on('ContentConcealer:ready', () => {
            $('.top-notice__close').off('click.TopNotice').on('click.TopNotice', this.close.bind(this));
        });
    }

    close(e) {
        const $el = $(e.currentTarget).closest('.top-notice');

        $el.slideUp(300, () => {
            Cookies.set(`tn_${$el.attr('data-id')}`, 1, { expires: 30 });
        });
    }
}